export interface CanvasBox {
  w: number;
  h: number;
}

/**
 * Game buffer that matches the viewport's aspect, so scale-to-fit has no bars.
 * The layout stays the same size and is centered inside the extra pixels.
 */
export function canvasFor(viewW: number, viewH: number, layoutW: number, layoutH: number): CanvasBox {
  if (viewW < 2 || viewH < 2 || layoutW < 2 || layoutH < 2) return { w: layoutW, h: layoutH };
  const viewAspect = viewW / viewH;
  const layoutAspect = layoutW / layoutH;
  if (Math.abs(viewAspect - layoutAspect) < 0.004) return { w: layoutW, h: layoutH };
  // Landscape around a portrait layout is letterboxed by scale-to-fit.
  // The buffer stays the portrait size so the column is centered, with bars on the sides.
  if (viewW > viewH && layoutH > layoutW) return { w: layoutW, h: layoutH };
  const even = (span: number, layout: number) => {
    let size = Math.max(layout, Math.round(span));
    if ((size - layout) % 2 !== 0) size += 1;
    return size;
  };
  if (viewAspect < layoutAspect) return { w: layoutW, h: even(layoutW / viewAspect, layoutH) };
  return { w: even(layoutH * viewAspect, layoutW), h: layoutH };
}
